import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';

import Login from './pages/Login';
import Home from './pages/Home';
import Cheques from './pages/Cheques';
import ContaCorrente from './pages/ContaCorrente';
import Fornecedores from './pages/Fornecedores';

import FinanceHome from './pages/FinanceHome.js';
import FinanceReports from './pages/FinanceReports';

// Componente para rotas protegidas
const PrivateRoute = ({ children }) => {
    const isAuthenticated = !!localStorage.getItem('token');

    if (!isAuthenticated) {
        return <Navigate to="/" replace />;
    }

    return children;
};

const AppRoutes = () => {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<Login />} />
                <Route
                    path="/home"
                    element={
                        <PrivateRoute>
                            <Home />
                        </PrivateRoute>
                    }
                />
                <Route path="*" element={<Navigate to="/" replace />} />
                <Route path="/banco/cheques" element={<Cheques />} />
                <Route path="/contacorrente" element={<ContaCorrente />} />
                <Route path="/fornecedor" element={<Fornecedores />} />
                <Route path="/finance/relatorios" element={<FinanceReports />} />
                <Route path="/finance" element={<FinanceHome />} />

            </Routes>
        </BrowserRouter>
    );
};

export default AppRoutes;